// Override REACT_APP properties that will be strings but we want to export as booleans.
const constants = {...process.env, ...{
  REACT_APP_ERROR_REPORTING_ENABLED: process.env.REACT_APP_ERROR_REPORTING_ENABLED?.toLowerCase() === 'true',
  REACT_APP_TELEMETRY_ENABLED: process.env.REACT_APP_TELEMETRY_ENABLED?.toLowerCase() === 'true'
}};

export const {
  REACT_APP_ERROR_REPORTING_ENABLED: ERROR_REPORTING_ENABLED,

  REACT_APP_TELEMETRY_APP_NAME: TELEMETRY_APP_NAME,

  REACT_APP_TELEMETRY_ENABLED: TELEMETRY_ENABLED,

  REACT_APP_SESSION_TIMEOUT_MIN: SESSION_TIMEOUT_MIN,

  REACT_APP_TOKEN_KEY: TOKEN_KEY,

  REACT_APP_SSO_AUTH_HEADER: SSO_AUTH_HEADER,

  REACT_APP_SSO_TOKEN_KEY: SSO_TOKEN_KEY,

  REACT_APP_SSO_REDIRECT_URI: SSO_REDIRECT_URI,

  REACT_APP_NOTIFICATION_UPDATE_INTERVAL_SEC: NOTIFICATION_UPDATE_INTERVAL_SEC,

  REACT_APP_API_PATH: API_PATH
} = constants;